// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".a0f86303b9e4ff00ef1f456cf5ad33b9.js";
};